//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SIM_PROVIDER_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    simProviderDeleteResult,
} from 'Redux/actions';

function* deleteSimProvider({ payload }) {
    try {
        let QUERY = `
            mutation deleteSimProvider ($id: Int!) {
                result: deleteSimProvider (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(simProviderDeleteResult({ delete: data?.result }))
        } else yield put(simProviderDeleteResult({ error: 'error-sim-provider' }))

    } catch (exc) {
        yield put(simProviderDeleteResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviders/views/.components/deleteSimProvider/redux/saga.js', 'deleteSimProvider');
    }
}

function* watchSimProvidersDeleteRequests() {
    yield takeEvery(SIM_PROVIDER_DELETE_REQUEST, deleteSimProvider);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSimProvidersDeleteRequests)
    ]);
}